import { Component, Inject } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { AddeableComponent } from '../../../../shared/components/interfaces/addeable.component';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { AssetTypeUIMessages } from '../../model/asset-type-ui.messages';
import { AssetTypeModel } from '../../model/asset-type.model';
import { AssetTypeService } from '../../service/asset-type.service';

@Component({
  selector: 'asset-type-add-dialog',
  templateUrl:
    'console/app-js/modules/assetType/components/asset-type-add-dialog/asset-type-add-dialog.component.html'
})
export class AssetTypeAddDialogComponent extends APIOperableComponent
  implements AddeableComponent {
  protected assetTypeModel: AssetTypeModel = new AssetTypeModel();
  private originalModel: AssetTypeModel;
  private assetTypeId: number;
  private allAssetTypes: Array<AssetTypeModel> = [];
  private currentAssetTypeNames: Array<string> = [];
  private profile: any;

  constructor(
    @Inject('assetTypeModel') assetType: AssetTypeModel,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private assetTypeService: AssetTypeService,
    private activeDialogService: UIActiveDialogService
  ) {
    super(progressService, toastr, authService);
    this.assetTypeId = assetType ? assetType.id : null;
    this.loadAllAssetTypes();
    this.getUserName();
  }

  /**
   * Get current username from user profile.
   */
  private getUserName() {
    this.profile = this.authService.getUserInfo();
  }

  /**
   * Loads all makes and extract it's names to validate.
   */
  private loadAllAssetTypes(): void {
    this.loadingIndicator = true;
    this.assetTypeService.getAssetTypes().subscribe(
      result => {
        this.allAssetTypes = result ? result : [];
        this.currentAssetTypeNames = this.allAssetTypes.map(item => item.name);
        this.loadingIndicator = false;
      },
      err => this.onAPIError(AssetTypeUIMessages.LOAD_ASSET_TYPE_LIST_ERROR)
    );
  }

  /**
   * Create new asset type onSave.
   */
  onSave(): void {
    this.startProgress();
    // Create
    this.assetTypeModel.isActive = true;
    this.assetTypeModel.createdBy = this.profile.nickname;
    this.assetTypeModel.updatedBy = this.profile.nickname;
    this.assetTypeService.createAssetType(this.assetTypeModel).subscribe(
      response => {
        if (response.responseCode === 200) {
          this.onAPISuccess(AssetTypeUIMessages.ADD_ASSET_TYPE_SUCCESS);
          this.activeDialogService.close(true);
          this.finishProgress();
        } else {
          this.onAPIError(AssetTypeUIMessages.ADD_ASSET_TYPE_ERROR);
        }
      },
      error => {
        this.onAPIError(AssetTypeUIMessages.ADD_ASSET_TYPE_ERROR);
      }
    );
  }

  /**
   * Check the form is dirty.
   */
  isDirty(): boolean {
    if (this.originalModel) {
      return (
        JSON.stringify(this.originalModel) !==
        JSON.stringify(this.assetTypeModel)
      );
    } else {
      // Create always dirty
      return true;
    }
  }

  /**
   * Cancel adding new asset type.
   */
  onCancel(): void {
    this.activeDialogService.dismiss();
  }

  /**
   * Determines if the current name input by user is already in use.
   * @returns {boolean}
   */
  protected isNameInUse(): boolean {
    const match =
      this.assetTypeModel.name &&
      this.currentAssetTypeNames.find(
        item =>
          item.toLocaleLowerCase().trim() ===
          this.assetTypeModel.name.trim().toLocaleLowerCase()
      );
    if (match && this.originalModel) {
      return (
        match.toLocaleLowerCase() !==
        this.originalModel.name.toLocaleLowerCase()
      );
    }
    return match && match.length > 0;
  }
}
